import clsx from "clsx";
import { useState } from "react";
import { toWorker } from "../../util/toWorker.ts";
import { confirm } from "../../util/confirm.tsx";
import { decisionConfirmVariants } from "../../util/decisionConfirmVariants.ts";
import i18n from "../../util/i18n.ts";

export const DraftButtons = ({
  className,
  mobile,
  spectator,
  userRemaining,
  usersTurn,
}: {
  className?: string;
  mobile?: boolean;
  spectator: boolean;
  userRemaining: boolean;
  usersTurn: boolean;
}) => {
  // This doesn't capture everything, since things can be triggered from outside of this component, but it's something
  const [running, setRunning] = useState(false);
  const buttonClassName = clsx("btn btn-light-bordered", {
    "btn-sm": mobile,
  });

  return (
    <div className={clsx(mobile ? "draft-buttons-mobile" : "btn-group", className)}>
      <button
        className={buttonClassName}
        disabled={(usersTurn && !spectator) || running}
        onClick={async () => {
          try {
            setRunning(true);
            await toWorker("playMenu", "onePick", undefined);
          } finally {
            setRunning(false);
          }
        }}
      >
        {i18n.t("draft.simOnePick", { ns: "ui", defaultValue: "Sim one pick" })}
      </button>
      <button
        className={buttonClassName}
        disabled={(usersTurn && !spectator) || !userRemaining || running}
        onClick={async () => {
          try {
            setRunning(true);
            await toWorker("playMenu", "untilYourNextPick", undefined);
          } finally {
            setRunning(false);
          }
        }}
      >
        {i18n.t("draft.toYourNextPick", { ns: "ui", defaultValue: "To your next pick" })}
      </button>
      <button
        className={buttonClassName}
        data-draft-buttons-ai-finish-action=""
        data-draft-ai-finish-command="untilEnd"
        data-draft-ai-finish-confirm-required={userRemaining && !spectator ? "true" : "false"}
        disabled={running}
        onClick={async () => {
          try {
            setRunning(true);
            if (userRemaining && !spectator) {
              const result = await confirm(
                i18n.t("draft.aiFinishConfirm", {
                  ns: "ui",
                  defaultValue:
                    "If you proceed, the AI will make your remaining picks for you. Are you sure?",
                }),
                {
                  okText: i18n.t("draft.letAiFinish", {
                    ns: "ui",
                    defaultValue: "Let AI finish the draft",
                  }),
                  cancelText: i18n.t("common.cancel", { ns: "ui", defaultValue: "Cancel" }),
                  variant: decisionConfirmVariants.draftAiFinish,
                },
              );

              if (!result) {
                return;
              }
            }
            await toWorker("playMenu", "untilEnd", undefined);
          } finally {
            setRunning(false);
          }
        }}
      >
        {i18n.t("draft.toEndOfDraft", { ns: "ui", defaultValue: "To end of draft" })}
      </button>
    </div>
  );
};
